import { render, staticRenderFns } from "./pacientHeader.vue?vue&type=template&id=2b4d5c5e"
import script from "./pacientHeader.vue?vue&type=script&lang=js"
export * from "./pacientHeader.vue?vue&type=script&lang=js"
import style0 from "./pacientHeader.vue?vue&type=style&index=0&id=2b4d5c5e&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.13_cache-loader@4.1.0_webpack@4.47.0_supports-_c8986591775dd8171f89195ce4da2f89/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports